import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StepsAutomaticAddStep from 'components/steps/StepsAutomaticAddStep';
import { isEmpty } from 'lodash';
import { withStyles } from '@material-ui/core';
import { getSteps } from 'redux/actions/stepActions';
import LoadingIcon from 'mdi-react/LoadingIcon';
import NotificationSystem from 'rc-notification';
import PitchPreviewDrawer from 'components/steps/Drawer/PitchPreviewDrawer';
import PitchQualityCheck from 'components/steps/Drawer/PitchQualityCheck';
import SequenceBuilderActions from './SequenceBuilderActions';

class PitchesPage extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    getSteps: PropTypes.func.isRequired,
    sequence: PropTypes.shape({
      id: PropTypes.number.isRequired,
      launch_date: PropTypes.string.isRequired,
      launch_date_time_zone: PropTypes.string.isRequired,
    }).isRequired,
    sequences: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
    }).isRequired,
    step: PropTypes.shape({
      loading: PropTypes.bool,
    }).isRequired,
    steps: PropTypes.shape({
      results: PropTypes.arrayOf(PropTypes.shape({
        pitches: PropTypes.arrayOf(PropTypes.shape({
          name: PropTypes.string,
          subject: PropTypes.string,
          body: PropTypes.string,
        })),
      })),
    }),
    campaign: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired,
    onBack: PropTypes.func.isRequired,
    onSkip: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    sequencePendingContacts: PropTypes.shape({
      total_valid_contacts: PropTypes.number,
    }).isRequired,
    sequenceContacts: PropTypes.shape({
      loading: PropTypes.bool,
    }).isRequired,
  };

  static defaultProps = {
    steps: {
      results: [],
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      launchCampaignModalOpen: false,
      pitchPreviewOpen: false,
      pitchQualityCheckOpen: false,
      pitchPreviewData: null,
    };
  }

  componentDidMount() {
    const { sequence } = this.props;

    this.props.getSteps({
      sequence: sequence.id,
    });
    // eslint-disable-next-line no-return-assign
    NotificationSystem.newInstance({}, n => this.notification = n);
  }

  componentWillUnmount() {
    this.notification.destroy();
  }

  launchCampaign = () => {
    const { launchCampaignModalOpen } = this.state;
    this.setState({
      launchCampaignModalOpen: !launchCampaignModalOpen,
    });
  }

  togglePitchPreview = (value) => {
    this.setState({
      pitchPreviewOpen: value === undefined ? !this.state.pitchPreviewOpen : value,
    });
  }

  togglePitchQualityCheck = (value) => {
    this.setState({
      pitchQualityCheckOpen: value === undefined ? !this.state.pitchQualityCheckOpen : value,
    });
  }

  updatePitchPreviewData = (data) => {
    this.setState({
      pitchPreviewData: data,
    });
  }

  toggleLaunchCampaignModal = () => {
    const { launchCampaignModalOpen } = this.state;
    this.setState({
      launchCampaignModalOpen: !launchCampaignModalOpen,
    });
  }

  render() {
    const {
      classes,
      sequence,
      sequences,
      steps,
      step,
      onBack,
      onSkip,
      onNext,
      onSave,
      sequenceContacts,
    } = this.props;
    const isLoading = sequenceContacts.loading ||
      sequence.loading ||
      sequences.loading ||
      step.loading ||
      steps.loading;
    return (
      <div className="sequence-contact-list__add-sequence-pitches mt-2">
        {isLoading && <div className="loader"><LoadingIcon /></div>}
        <div className="instance-form__body">
          <div className="flex">
            <div className={classes.stepsContainer}>
              <StepsAutomaticAddStep
                steps={steps.results || []}
                pitchQualityCheckData={this.state.pitchQualityCheckData}
                togglePitchPreview={this.togglePitchPreview}
                togglePitchQualityCheck={this.togglePitchQualityCheck}
                updatePitchPreviewData={this.updatePitchPreviewData}
                pitchQualityCheckOpen={this.state.pitchQualityCheckOpen}
              />
            </div>
            {this.state.pitchPreviewOpen &&
              <PitchPreviewDrawer
                data={this.state.pitchPreviewData}
                className={classes.drawer}
              />
            }
            {this.state.pitchQualityCheckOpen &&
              <PitchQualityCheck />
            }
          </div>
        </div>
        <SequenceBuilderActions
          onBack={onBack}
          onSkip={onSkip}
          onSave={onSave}
          onNext={onNext}
          disabledSave={isLoading || isEmpty(steps.results)}
          disabledNext={isLoading || isEmpty(steps.results)}
        />
      </div>
    );
  }
}

const styles = theme => ({
  stepsContainer: {
    width: '100%',
    padding: '1rem 1rem 1rem 1.5rem',
    backgroundColor: theme.palette.secondary[50],
    borderRadius: '8px',
  },
  drawer: {
    marginLeft: '1rem',
    paddingRight: '0',
    marginTop: '-32px',
  },
});

export default compose(
  withStyles(styles),
  connect(
    state => ({
      sequence: state.sequence,
      sequences: state.sequences,
      sequencePendingContacts: state.previewContacts,
      sequenceContacts: state.sequenceContacts,
      campaign: state.campaign,
      steps: state.steps,
      step: state.step,
    }),
    {
      getSteps,
    },
  ),
)(PitchesPage);
